// @flow
import {
  WebComponent,
} from 'fg-frontend';
import 'plugins/Leaflet.js';

export default class Webmap extends WebComponent {

  didMount() {

    // Vlastní marker
    const customIcon = L.icon({
      iconUrl: '/img/main/marker2.png',
      iconSize: [50, 70],
      iconAnchor: [25, 70]
    });

    /*
    We also require you to include our logo somewhere over the map.
    We create our own map control implementing a documented interface,
    that shows a clickable logo.
    See https://leafletjs.com/reference.html#control
    */
    const LogoControl = L.Control.extend({
      options: {
        position: 'bottomleft',
      },

      onAdd: function (map) {
        const container = L.DomUtil.create('div');
        const link = L.DomUtil.create('a', '', container);

        link.setAttribute('href', 'http://mapy.com/');
        link.setAttribute('target', '_blank');
        link.innerHTML = '<img src="https://api.mapy.com/img/api/logo.svg" />';
        L.DomEvent.disableClickPropagation(link);

        return container;
      },
    });

    // Ověření existence elementu s id "m" nebo "mc"
    const container = document.getElementById('m');
     if (container) {
      const map = L.map('m').setView([50.0899537, 14.4005384], 15);
       // Přidání Mapy.cz vrstvy s API klíčem
       L.tileLayer('https://api.mapy.com/v1/maptiles/{mapset}/{tileSize}/{z}/{x}/{y}?apikey=nXeJs5GpqwOT9042vzOzL15eqsUvZPbu9OZ2155xJQs', {
         mapset: 'basic',
         tileSize: 256,
         minZoom: 0,
         maxZoom: 19,
         attribution: '<a href="https://api.mapy.com/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
       }).addTo(map);

       // finally we add Logoto the map
       new LogoControl().addTo(map);

       L.marker([50.0899537, 14.4005384], {icon: customIcon}).addTo(map);
     }

    const containerContent = document.getElementById('mc');
    if (containerContent) {
      const mapContent = L.map('mc').setView([50.0899537, 14.4005384], 15);
      // Přidání Mapy.cz vrstvy s API klíčem
      L.tileLayer('https://api.mapy.com/v1/maptiles/{mapset}/{tileSize}/{z}/{x}/{y}?apikey=nXeJs5GpqwOT9042vzOzL15eqsUvZPbu9OZ2155xJQs', {
        mapset: 'basic',
        tileSize: 256,
        minZoom: 0,
        maxZoom: 19,
        attribution: '<a href="https://api.mapy.com/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
      }).addTo(mapContent);

      // finally we add Logoto the map
      new LogoControl().addTo(mapContent);

      L.marker([50.0899537, 14.4005384], {icon: customIcon}).addTo(mapContent);
    }



  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Webmap.js